import * as tslib_1 from "tslib";
import Vue from 'vue';
import Component from 'vue-class-component';
import { Card, Checkbox, Button } from '@/components/UIComponents';
import swal from 'sweetalert2';
import { AuthenticationDAO } from "@/API/DAO/AuthenticationDAO";
let RecoverPasswordViewModel = class RecoverPasswordViewModel extends Vue {
    constructor() {
        super();
        this.emailAddress = '';
        this.emailAddress = '';
    }
    getError(fieldName) {
        return this.$validator.errors.first(fieldName);
    }
    get emailValidation() {
        return {
            email: true,
            required: true,
            min: 2
        };
    }
    async sendEmailConfirmation() {
        try {
            await AuthenticationDAO.recoverPassword(this.emailAddress);
            await swal.fire({
                title: `Recovery Email Sent`,
                text: `We have sent instructions on how to reset your password to ` + this.emailAddress,
                buttonsStyling: false,
                confirmButtonClass: 'btn btn-info btn-fill'
            });
            this.$router.push({ name: 'IdentityNewLogin', query: this.$route.query });
        }
        catch (error) {
            console.log('Failed to post recovery requests. ' + error);
            await swal.fire({
                title: `Recovery Email Failed`,
                text: JSON.stringify(error),
                buttonsStyling: false,
                confirmButtonClass: 'btn btn-info btn-fill'
            });
        }
    }
    mounted() {
    }
};
RecoverPasswordViewModel = tslib_1.__decorate([
    Component({
        components: {
            [Card.name]: Card,
            [Checkbox.name]: Checkbox,
            [Button.name]: Button
        }
    })
], RecoverPasswordViewModel);
export default RecoverPasswordViewModel;
